module.exports = __webpack_public_path__ + "img/map_icon_white.db7c5f64.svg";